import { useRecordContext, useGetList, Loading, useTranslate, useLocaleState } from 'react-admin';
import {
  Box,
  Typography,
  Chip,
  List as MuiList,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import type { Channel, ChannelConnection } from '../../../../types/chat.types';

export const ChannelConnections = () => {
  const record = useRecordContext<Channel>();
  const translate = useTranslate();
  const [locale] = useLocaleState();

  const { data: connections, isLoading } = useGetList<ChannelConnection>(
    'channel-connection',
    {
      filter: { channelId_eq: record?.id },
      pagination: { page: 1, perPage: 50 },
      sort: { field: 'createdAt', order: 'DESC' },
    },
    { enabled: !!record?.id }
  );

  if (isLoading) return <Loading />;
  if (!connections?.length) {
    return <Typography color="textSecondary">{translate('resources.channel.empty.subtitle')}</Typography>;
  }

  return (
    <MuiList dense>
      {connections.map((connection) => (
        <ListItem key={connection.id}>
          <ListItemIcon>
            <LinkIcon color={connection.isConnected ? 'success' : 'error'} />
          </ListItemIcon>
          <ListItemText
            primary={connection.displayName || connection.identifier}
            secondary={
              <Box>
                <Typography variant="caption" color="textSecondary">
                  {connection.identifier}
                </Typography>
                <Box display="flex" gap={1} mt={0.5}>
                  <Chip
                    label={connection.isConnected ? translate('resources.channel.connection.connected') : translate('resources.channel.connection.disconnected')}
                    size="small"
                    color={connection.isConnected ? 'success' : 'error'}
                    variant="outlined"
                  />
                  {connection.lastSyncAt && (
                    <Typography variant="caption" color="textSecondary">
                      {new Date(connection.lastSyncAt).toLocaleString(locale)}
                    </Typography>
                  )}
                </Box>
              </Box>
            }
          />
        </ListItem>
      ))}
    </MuiList>
  );
};
